export const orderInit = {
  currentStep: 0,
  visitedSteps: [0],
  data: {
    step0: {},
    step1: {},
    step2: {},
    step3: {},
    global: {
      orderDetail: {
        plateNo: '',
        modelName: '',
        brandName: '',
        seriesName: '',
        rentCategoryName: '',
        startDate: '',
        endDate: '',
        state: '',
        tel: '',
        customerName: '',
        vin: '',
      },
      orderId: '',
      isRenew: false,
    },
  },
}
